module.exports = __webpack_public_path__ + "img/flecha.51cb5704.png";